<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>
      <div style="background-color: rgba(255, 255, 255, .9); margin-top: 200px;">
        <v-container class="site-padding" id="aboutActionSection">
          <v-layout row wrap class="ambasadors-container">
            <v-flex xs12 class="text-xs-left">
              <h1 class="my-header ambasadors-container--header pt-4">Ambasadorzy Akcji</h1>
              <div class="sparator-container pt-4">
                <div class="sparator-rectangle"></div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-text ambasadors-container py-4">
            <v-flex xs12 md6 class="text-xs-left">
              <div class="banner pt-2">
                <div class="wrapper">
                  <div class="text-container px-2 px-md-0">
                    <div class="ambasadors-container--download">
                      <v-avatar
                        :size="80"
                      >
                        <img src="./../assets/images/face2a.png" alt="">
                      </v-avatar>
                      <div class="ambasadors-container--download-text">
                        <span class="ban2">prof. dr hab. n. med.</span>
                        <span class="ambasadors-container--sections">Iwona Grabska-Liberek</span>
                        <span class="ban2 text-uppercase">Wiceprezes Polskiego Towarzystwa Okulistycznego</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left">
              <div class="pt-2">
                <span class="ambasadors-container--sections">
                  Drogie Koleżanki, Drodzy Koledzy
                </span>
              </div>
              <div>Badania przesiewowe narządu wzroku są podstawowym, skutecznym i&nbsp;tanim narzędziem, które ma na celu wyłonienie grupy osób wymagających dalszej diagnostyki. Wczesne rozpoznanie wad lub chorób jest kluczowym czynnikiem dokonania skutecznej korekcji, podjęcia leczenia lub spowolnienia procesu chorobowego. Zapobieganie i&nbsp;wczesne rozpoczęcie leczenia jest bardziej ekonomiczne, niż drogie i&nbsp;długotrwałe leczenie późno wykrytych schorzeń.</div>
              <div>Polskie Towarzystwo Okulistyczne cyklicznie prowadzi badania przesiewowe w&nbsp;kierunku jaskry od 2016&nbsp;roku angażując wszystkich chętnych do włączenia się w&nbsp;akcję "Polscy okuliści kontra jaskra" w&nbsp;trakcie Światowego Tygodnia Jaskry w&nbsp;marcu. To bardzo ważne, by umożliwiać naszym pacjentom dostęp do specjalisty. Zachęcam więc wszystkich Państwa  by tak jak ja i&nbsp;cały Zarząd również w&nbsp;2019 roku włączyli się do akcji i&nbsp;zgłosili swoje gabinety za pomocą formularza dostępnego na stronie.</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-text ambasadors-container py-4">
            <v-flex xs12 md6 class="text-xs-left">
              <div class="banner pt-2">
                <div class="wrapper">
                  <div class="text-container px-2 px-md-0">
                    <div class="ambasadors-container--download">
                      <v-avatar
                        :size="80"
                      >
                        <img src="./../assets/images/face3a.png" alt="">
                      </v-avatar>
                      <div class="ambasadors-container--download-text">
                        <span class="ban2">prof. dr hab. n. med.</span>
                        <span class="ambasadors-container--sections">Bożena Romanowska-Dixon</span>
                        <span class="ban2">WICEPREZES POLSKIEGO TOWARZYSTWA OKULISTYCZNEGO</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left">
              <div class="pt-2">
                <span class="ambasadors-container--sections">
                  Dlaczego zdecydowałam się aktywnie włączyć w&nbsp;akcję Polscy Okuliści Kontra Jaskra?
                </span>
              </div>
              <div>Otóż na świecie jaskra dotyka około 3,54% osób powyżej 40. roku życia. Co w&nbsp;praktyce oznacza, że około 60 milionów osób cierpi na jaskrę, z&nbsp;czego około 10% procent z&nbsp;powodu jaskry jest obuocznie niewidomych. Tak wysoki odsetek osób ślepych związany jest z&nbsp;bezobjawowym przebiegiem choroby, nieregularnymi kontrolami okulistycznymi oraz późnym postawieniem rozpoznania - często w&nbsp;momencie, gdy uszkodzenia spowodowane przez jaskrę są zaawansowane. w&nbsp;Polsce aż 70% przypadków jaskry wykrywanych jest zbyt późno, by uratować widzenie, nawet przy intensywnym leczeniu.</div>
              <div>Statystyki są bezwzględne i&nbsp;dlatego zależy mi na nagłośnieniu akcji, aby w&nbsp;jak największym stopniu zminimalizować ryzyko zachorowania i&nbsp;ustrzec pacjentów przed nieodwracalnymi konsekwencjami bagatelizowania badań.</div>
              <div>Chrońmy nasze oczy!</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-text ambasadors-container py-4">
            <v-flex xs12 md6 class="text-xs-left">
              <div class="banner pt-2">
                <div class="wrapper">
                  <div class="text-container px-4 px-md-0">
                    <div class="ambasadors-container--download">
                      <v-avatar
                        :size="80"
                      >
                        <img src="./../assets/images/face4a.png" alt="">
                      </v-avatar>
                      <div class="ambasadors-container--download-text">
                        <span class="ban2">prof. dr hab. n. med.</span>
                        <span class="ambasadors-container--sections">Jacek P. Szaflik</span>
                        <span class="ban2">PREZES ELEKT POLSKIEGO TOWARZYSTWA OKULISTYCZNEGO</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left">
              <span class="pt-2" v-if="isSzaflik">Lorem Ipsum jest tekstem stosowanym jako przykładowy wypełniacz w&nbsp;przemyśle poligraficznym. Został po raz pierwszy użyty w&nbsp;XV w. przez nieznanego drukarza do wypełnienia tekstem próbnej książki. Pięć wieków później zaczął być używany przemyśle elektronicznym, pozostając praktycznie niezmienionym. Spopularyzował się w&nbsp;latach 60. XX w. wraz z&nbsp;publikacją arkuszy Letrasetu, zawierających fragmenty Lorem Ipsum, a&nbsp;ostatnio z&nbsp;zawierającym różne wersje Lorem Ipsum oprogramowaniem przeznaczonym do realizacji druków na komputerach osobistych, jak Aldus PageMaker</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="my-text ambasadors-container">
            <v-flex xs12 md6 class="text-xs-left">
              <div class="banner pt-2">
                <div class="wrapper">
                  <div class="text-container px-4 px-md-0">
                    <div class="ambasadors-container--download">
                      <v-avatar
                        :size="80"
                      >
                        <img src="./../assets/images/face1a.png" alt="">
                      </v-avatar>
                      <div class="ambasadors-container--download-text">
                        <span class="ban2">dr hab. n. med.</span>
                        <span class="ambasadors-container--sections">Anna Kamińska</span>
                        <span class="ban2">PRZEWODNICZĄCA SEKCJI JASKRY POLSKIEGO TOWARZYSTWA OKULISTYCZNEGO</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left">
              <div class="pt-2">
                <span class="ambasadors-container--sections">
                  Dlaczego warto uczestniczyć w&nbsp;akcji ,,Polscy okuliści kontra jaskra”?
                </span>
              </div>
              <div>Na jaskrę choruje około 70 milionów ludzi na świecie i&nbsp;co roku liczba ta rośnie szacunkowo o kolejne 7,5 mln osób. Według Światowej Organizacji Zdrowia jaskra pierwotna otwartego kąta stanowi drugą co do częstości przyczynę ślepoty w&nbsp;krajach wysoko rozwiniętych, po 40 roku życia na jaskrę pierwotną otwartego kąta ma szansę zachorować 1% populacji i&nbsp;ryzyko wzrasta wraz z&nbsp;wiekiem.</div>
              <div>Pomimo wdrażania nowych metod diagnostycznych i&nbsp;terapeutycznych jaskra stanowi w&nbsp;dalszym ciągu poważny problem medyczny i&nbsp;społeczny ze względu na zbyt późne zgłaszanie się pacjentów do lekarzy okulistów.</div>
              <div>Celem akcji ,,Polscy okuliści kontra jaskra” jest szerzenie wiedzy na temat jaskry zarówno wśród pacjentów jak i&nbsp;lekarzy innych specjalności, co pozwoli na wcześniejszą diagnostykę, a&nbsp;wprzypadkach rozpoznanej choroby na lepszą współpracę z&nbsp;pacjentem. Brak wiedzy na temat konsekwencjizaniechania leczenia bądź niesystematycznej opieki specjalistycznej wpływa na złe rokowanie pacjenta chorego na jaskrę i&nbsp;nieuchronnie prowadzi do ślepoty. Chcielibyśmy zachęcić do badań profilaktycznych, co pozwoli wyodrębnić grupę ryzyka pacjentów, którzy wymagają przeprowadzenia pełnej diagnostyki w&nbsp;kierunku jaskry i&nbsp;w&nbsp;przypadku wykrycia choroby wdrożenia adekwatnej terapii.</div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <div class="header-separator" style="height: 50px;"></div>
  </div>
</template>

<script>
import MyButton from '@/components/partials/Button';
import DoctorHeader from '@/components/partials/DoctorHeader';
import Countdown from '@/components/partials/Countdown';
import VueScrollTo from 'vue-scrollto';

export default {
  data() {
    return {
      isSzaflik: false,
      valid: true,
      time: null,
      form: [
        { id: 'first_name', model: 'first_name', type: 'text', name: 'first_name' },
        { id: 'phone', model: 'phone', type: 'text', name: 'phone' },
        { id: 'email', model: 'email', type: 'text', name: 'email' },
        { id: 'message', model: 'message', type: 'text', name: 'comment' },
      ],
      nameRules: [
        v => !!v || 'Pole jest wymagane',
      ],
      emailRules: [
        v => !!v || 'E-mail jest wymagany',
        v => /.+@.+/.test(v) || 'Zły format',
      ],
    };
  },
  components: {
    DoctorHeader,
    Countdown,
    MyButton,
  },
  watch: {
    '$route': function(){
      if(this.$route.hash) {
        this.scrollToSection(this.$route.hash);
      }
    }
  },
  mounted() {
   this.fetchTime()
    if(this.$route.hash) {
      this.scrollToSection(this.$route.hash);
    }
  },
  beforeMount() {},
  methods: {
    scrollToSection(section) {
      const options = {
        container: 'body',
        duration: 500,
        easing: 'ease',
        offset: -200,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true,
      };

      VueScrollTo.scrollTo(section, 300, options);
    },
    goRegister() {
      this.$router.push({
        name: 'Register',
      });
    },
    fetchTime() {
      this.axios({
        method: 'GET',
        url: `${process.env.APP_URL}/api/time`,
      })
      .then(response => {
        this.time = response.data[0].dateToCheck;
      })
    },
    clearForm() {
      this.form.name = '';
      this.form.phone = '';
      this.form.email = '';
      this.form.message = '';
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isDisabled = true;
        const data = {
            "form" :
            {
              "name": this.form.name,
              "email": this.form.email,
              "phone": this.form.phone,
              "message": this.form.message
            }
          }
        this.axios({
          method: "POST",
          url: `${process.env.APP_URL}/api/send`,
          data
        })
        .then((response) => {
          this.isDisabled = false;

          this.clearForm()
          this.$refs.form.reset();

          this.$toasted.success('Dziękujemy za wiadomość, odpowiemy jak najszybciej.', {
          theme: "primary",
          position: "bottom-right",
          duration : 5000
        })
        }, (response) => {
          this.isDisabled = false;

          Object.keys(response.response.data.errors).map((key) => response.response.data.errors[key].map((error) => this.showErrors(error)))
        })
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ambasadors-container--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}
.ambasadors-container--header {
  color: rgb(164, 22, 17);
}
.ambasadors-container--sections {
  color: #275271;
  font-family: 'Fira Sans', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
.ambasadors-container--sections-brown {
  color: #a41611;
}
.ambasadors-container--sections-slim {
  color: #000;
  font-weight: 500;
  text-transform: lowercase;
}
.ambasadors-container--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  line-height: 120px;
  border: none;
  padding: 20px;
}
.ambasadors-container--icons-brown {
  background: #a82824;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}
.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}
.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}
.register-bg {
  position: relative;
}
.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: '';
  position: fixed;
  opacity: 0.1;
  background-image: url('./../assets/images/register-bg.png');
  background-repeat: repeat;
  background-position: center center;
}
.doctor-header {
  background: #a82824;
  opacity: 0.9;
}
.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}
.free-main-header--text {
  font-family: 'Fira Sans', sans-serif;
  font-size: 12px;
}
.main-header--wgw {
  width: 125px;
}
.main-header--pto {
  width: 90px;
}
@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }
  .main-header--pto {
    width: 200px;
  }
}
.ambasadors-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  color: #000;
}
.ambasadors-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
  font-size: 18px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Ambasadors.vue